export const submitConfigApi = function (params) {
    return Util.ajax.post('mis_config/update',params).then((response) => {
                   return response.data;
          }).then((res) => {
              if(res.code === 1) {
                 this.$Message.success(params.id===0?'新增成功！':'编辑成功！')
                 return res
              }else{
                  this.$Modal.error({
                      title: '错误',
                      content: res.msg
                  });
              }
              return res
          }).catch(() => {
              this.$Modal.error({
                  title: '错误',
                  content: '网络异常'
              });
          })
  }
  
  export const getConfigApi = function (params,callBack) {
   return Util.ajax.get('mis_config/detail',{ params }).then((response) => {
                   return response.data;
          }).then((res) => {
              if(res.code === 1) {
               return res.data.config
              }else{
                  this.$Modal.error({
                      title: '错误',
                      content: res.msg,
                      onOk:callBack
                  });
                  return res
              }
          }).catch(() => {
              this.$Modal.error({
                  title: '错误',
                  content: '网络异常',
                  onOk:callBack
              });
          }); 
  }